import { Paper as MuiPaper, paperClasses, styled } from '@mui/material';
import type { PaperProps as MuiPaperProps } from '@mui/material';
import { insidePaperFullWidthStyles, paperPaddingStyles } from './utils.ts';

export type PaperProps = MuiPaperProps & {
    responsive?: boolean;
    zeroPadding?: boolean;
};

export const Paper = styled(MuiPaper, {
    shouldForwardProp(propName) {
        return propName !== 'responsive' && propName !== 'zeroPadding';
    },
})<PaperProps>(({ theme, responsive, zeroPadding }) => ({
    textAlign: 'left',
    border: 'none',
    boxSizing: 'border-box',
    [`& .${paperClasses.elevation10}`]: {
        boxShadow: '0 8px 16px 0 rgba(0, 0, 0, 0.08)',
    },
    ...(zeroPadding ? { padding: 0 } : paperPaddingStyles(theme, responsive)),
}));

/**
 * Some views may want to have a responsive paper, but then inside the paper
 * have a full width view. This solution resets the responsiveness declared
 * in the Paper component
 *
 * Usage:
 *
 *  <Paper>
 *          some content, this will have padding depending on screen size
 *          <FullWidthInsidePaper>
 *              More content, which will have margins that resets the padding
 *          </FullWidthInsidePaper>
 *  </Paper>
 *
 *  This solution is not optimal, and is rather a quick and dirty solution. A
 *  better solution must be though of, probably by using helper that contain
 *  the style definitions needed, because, we might also want the same padding
 *  inside components rendered within <FullWidthInsidePaper />, but now we risk
 *  that they are not the same, but at least we avoid having layouts that
 *  overflow.
 */
export const FullWidthInsidePaper = styled('div')(({ theme }) => ({
    ...insidePaperFullWidthStyles(theme),
}));
